import React from 'react';
import { useLocation } from 'react-router-dom';
import { getPublicPageSeo } from '../../../seo/publicPages';
import { usePageBanners } from '../../../hooks/usePageBanners';
import PageBanner from '../PageBanner/PageBanner';
import './PricingHero.css';

const SECTION = 'Pricing';

const PricingHero = () => {
  const { pathname } = useLocation();
  const seo = getPublicPageSeo(pathname);
  const pageTitle = seo?.pageTitle || 'Pricing';
  const heading = seo?.heading || 'Simple module pricing. Start free.';
  const { hasDynamicBanner, banners } = usePageBanners(SECTION);
  const titleSectionClass = hasDynamicBanner
    ? 'pricing-hero-title-section pricing-hero-title-section--below-banner'
    : 'pricing-hero-title-section pricing-hero-title-section--standalone';

  return (
    <section className="pricing-hero">
      {hasDynamicBanner && (
        <PageBanner banners={banners} heading={pageTitle} subheading={heading} />
      )}
      <div className={titleSectionClass}>
        <div className="container">
          <div className="pricing-hero-content">
            <h1 className="pricing-title">
              {pageTitle}
            </h1>
            <p className="pricing-subtitle">
              {heading}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingHero;
